import axios from "axios";

export function loadFields(reportId) {
    return axios.get(`/api/report/getfields/${reportId}`)
        .then(response => ({ response }))
        .catch(error => ({ error }));
}

export function saveLayout(reportId, layout) {
    var data = new FormData();
    data.append('layout', JSON.stringify(layout));

    return axios.post(`/api/report/savelayout/${reportId}`, data)
        .then(response => ({ response }))
        .catch(error => ({ error }));
}